<script>
  export let tour;
  import Krpano from "./Krpano.svelte";

  /* ____________ Mobile Detection ____________ */
  import UA from "ua-parser-js";
  const ua = new UA();
  let isMobile = ua.getResult().device["type"] == "mobile";
  
  let orientationInstructionsVisible = false;

  // Function to check the orientation
  function checkOrientation() {
    orientationInstructionsVisible = window.matchMedia("(orientation: portrait)").matches;
  }

  // Add event listener for orientation changes
  window.addEventListener("resize", checkOrientation);

  // Check on mount
  checkOrientation();
</script>

<!-- orientation to landscape instructions -->
{#if isMobile && orientationInstructionsVisible}
  <div class="orientation-instructions">
    <img src="skin/rotate_device.png" alt="Rotate your device to landscape" />
    <p>To experience VR, <br/> Please rotate your device to landscape.</p>
  </div>
{/if}

<Krpano 
  config={tour} 
  xml="vr.xml"
  loaderEnabled={false}
/>

<style>
  /* CSS media query to hide the instructions in landscape mode */
  @media (orientation: landscape) {
    .orientation-instructions {
      display: none;
    }
  }

  .orientation-instructions {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #000;
    color: white;
    text-align: center;
    z-index: 1000;
    width: 100%;
    height: 100%;
  }

  .orientation-instructions p {
    padding-inline: 1em;
    font-size: 1.2em;
  }

  .orientation-instructions img {
    max-width: 200px;
    margin-bottom: 2em;
    width: 100%;
  }
</style>
